interface Window {
    dataLayer: any[];
}

const productViewDatalayer = (): void => {
    if (document.body.classList.contains('single-product')) {
        const productElement = document.querySelector('.product');
        if (!productElement) return;

        const variationForm = document.querySelector('.variations_form');
        const isVariableProduct = !!variationForm;
        
        let productId = productElement.getAttribute('data-product_id') || '';
        
        if (isVariableProduct) {
            const parentId = variationForm?.getAttribute('data-product_id');
            if (parentId) {
                productId = parentId;
            }
        }
        
        const productName = document.querySelector('.product_title')?.textContent?.trim() || '';
        const productData = {
            event: 'parent_view_item',
            ecommerce: {
                items: [{
                    item_name: productName,
                    item_id: productId,
                }]
            }
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(productData);
    }
};

export default productViewDatalayer;
